<template>
  <div class="courseDetail">
    <van-nav-bar
      :title="description.name || ''"
      left-arrow
      @click-left="goback"
    />
    <ul class="clarityStyle" v-if="isAndroid && currentlyPlay && [1].includes(+currentlyPlay.type)">
      <li class="fr currently" @click="() => { this.clarityShow = !this.clarityShow }">{{clarity[videoInfo.videoClarity].val}}</li>
      <li v-show="clarityShow" class="fr" @click="cutoverClarity(item.key)" v-for="(item, index) in clarity" :key="index">{{item.val}}</li>
      <li class="clear"></li>
    </ul>
    <div class="playPlayer">
        <!-- 播放按钮图片 -->
        <img
            class="picBfImg"
            v-if="
            isPic() &&
            currentlyPlay &&
            [1, 2].includes(+currentlyPlay.type) &&
            this.allresouce.length && playCover
            "
            @click="selectPlay(currentlyPlay)"
            src="./../../../assets/images/course/bf.png"
        />
        <!-- 课程封面 -->
        <div :class="'picImg'" v-if="isPic() && playCover">
            <img class="picImg-img" :src="descriptionImg"/>
        </div>
        <div
            :class="isstartPlay ? 'detectnone' : 'detect'"
            v-show="+TrainBasicInfo.isAlertWindow === 1 && this.studyProcess < 100"
        >
            <div>
            本课程开启了“学时防作弊”，如果全屏播放视频时出现暂停，请退出全屏按提示操作后可继续学习
            </div>
            <van-button type="default" @click="selectPlay(currentlyPlay)">知道了</van-button>
        </div>
        <div
            id="player-con"
        >
        <!-- v-show="videoInfo.detect && currentlyPlay && [1, 2].includes(+currentlyPlay.type)" -->
            <!-- 播放器 -->
            <coursePlay ref="Aliplayer" @ended="playEnd" @play="startPlay" @pause="playPause" :currentlyPlay="currentlyPlay" :isDraw="+isDraw" :isDoubleSpeed="+isDoubleSpeed" ></coursePlay>

        </div>
        </div>
        <div class="courseDetail-content">
        <div class="content-header">
            <ul>
            <li
                class="headerspan"
                @click="changecourseType(item)"
                :class="changetype === item.id ? 'spanactive1' : ''"
                v-for="(item, index) in contentType"
                :key="index"
            >
                <span>{{ item.name }}</span>
            </li>
            <li class="evaluation">
                <p v-for="itemcount1 in count" :key="itemcount1">
                <img src="../../../assets/images/course/pfwjx.png" alt="">
                </p>
                <p v-for="itemcount2 in 5-count" :key="itemcount2+count">
                <img src="../../../assets/images/course/pfwjx1.png" alt="">
                </p>
                <p>{{count1.toFixed(1)}}分</p>
            </li>
            <li class="goevaluation" @click="playboxscoreclick">
                {{myScore>0?'已评分':'未评分'}}
            </li>
            </ul>
        </div>
        <div v-if="changetype === '0'" class="content-info content-info-course">
            <p v-html="description.description">
            </p>
        </div>
        <div v-if="changetype === '1'" class="content-catalog">
            <div class="category-wraper">
            <div
                class="category-item"
                v-for="(item, index) in catelogList"
                v-show="item.showTag"
                :key="item.id"
            >
                <!-- 章 -->
                <div
                class="category-item-header"
                :class="currentCourseId === item.id && 'actived'"
                @click="handleToggle(item,1)"
                >
                <div class="title">{{ index + 1 }}. {{ item.name }}</div>

                <div
                    class="open"
                    :class="currentCourseId === item.id && 'actived'"
                >
                    <svg-icon icon-class="arrow-icon" class-name="arrow-icon"></svg-icon>
                </div>
                <div class="course-status" v-if="item.lock">
                    <svg-icon icon-class="lock" class-name="lock-icon"></svg-icon>
                </div>
                </div>

                <div
                class="category-item-content"
                v-if="currentCourseId === item.id"
                >
                <!-- 没有小节 直接展示课程 -->
                <template v-for="(el, index) in item.childrenList">
                    <!-- type === 0 目录 type !== 0 资源 -->
                    <course-item
                    :key="el.id"
                    v-if="el.type !== 0"
                    :info="el"
                    :dateExpireStatus="dateExpireStatus"
                    :currentlyPlay="currentlyPlay"
                    :isb="index !== item.childrenList.length - 1"
                    ></course-item>
                    <course-section
                    v-else
                    :key="el.id"
                    :info="el"
                    :dateExpireStatus="dateExpireStatus"
                    :currentlyPlay="currentlyPlay"
                    :isb="index !== item.childrenList.length - 1"
                    ></course-section>
                </template>
                </div>
            </div>
            </div>
        </div>
        <div v-if="changetype === '2'" class="content-catalog">
            <div class="category-wraper">
            <homework-list :taskId="$route.query.trainId" :courseId="courseId"/>

            </div>
        </div>
        </div>
        <div v-show="false" ref="audioRef">音频</div>
        <facedialog v-if="isfacedialog" :courseId="courseId"  @close="close"></facedialog>
        <playboxscore v-if="playboxscore" :myScore="myScore" :issubmit="myScore>0?false:true"></playboxscore>
        <van-dialog class="coursedialog" v-model="courseshow" :show-confirm-button="false">
            <div class="coursedialog-content">{{coursetxt}}</div>
            <van-button class="coursedialog-btn" @click="courseshowbtn">知道了（{{djscount}}S后关闭）</van-button>
        </van-dialog>
    </div>
</template>
<script>

/* eslint-disable */
import CourseItem from './components/course.vue';
import CourseSection from './components/selection.vue';
import facedialog from "./../../../layout/facedialog.vue";
import playboxscore from "./../../../layout/playboxscore";
import HomeworkList from './components/homeworkList.vue';
import coursePlay from './play.vue'
import { goLiveHome } from '../../../utils/livePlatform'
export default {
  name: "Course",
  components: {
    CourseItem,
    CourseSection,
    facedialog,
    playboxscore,
    HomeworkList,
    coursePlay
  },

  data () {
    return {
      isDraw:0, // 是否防拖拽
      isDoubleSpeed:0,// 防倍速
      studyProcess:'',
      playCover:true,
      fileUrl:'',
      djscount:2,
      coursetxt:'',
      courseshow:false,
      isAndroid: false,
      clarityShow: false,
      clarity: {
        LD: {
          key: 'LD',
          val: '标清'
        },
        SD: {
          key: 'SD',
          val: '高清'
        }
      },
      sourceId: 0,
      playboxscore:false,
      count:0,
      count1:0,
      myScore:0,
      imgOrPdf: false,
      isstartPlay: false,
      endedStatue: true,
      dateExpireStatus: null,
      WDuserInfo: {},
      isfacedialog: false,
      changetype: "1",
      description: {
        pic: ''
      },
      descriptionImg: 'https://raas-prod.oss-cn-beijing.aliyuncs.com/hrss/default-picture/course2.png',
      catelogList: [],
      allresouce: [],
      params: {
        courseId: 85,
        taskId: 1
      },
      TrainBasicInfo: {},
      contentType: [
        { name: "简介", id: "0" },
        { name: "目录", id: "1" },
        { name: "作业", id: "2" },

      ],
      videoInfo: {
        videoType: {
          format: 'mp3',
          mediaType: 'audio'
        },
        videoClarity: 'LD',
        video: null,
        url: [],
        source: {},
        deadline: 0,
        clarity: 0,
        index: 0,
        playPlayer: false,
        fastForward: true,
        detect: true,
        IosInif: true,
        notdialog: true,
      },
      currentlyPlay: {},
      userLearnInfo:{},
      courseInfo: {
        id: 1,
        name: "课程",
        intro: ''
      },
      currentCourseId: null,
      IntervalName: null,
      timeoutDialogAlert: null,
      accessToken:'',
      // currentResource:{},
      courseId:null,// 当前播放的课程id
      saveLogCode:null,
      saveLogtime:5000, // 保存接口 定时器时间
      // canToQuicklyStudy:false,//是否可以点击立即学习/快速学习
      // toStudyByQuick:false,//学习资源的方式
    };
  },
  watch:{
        courseshow: {
          handler(n) {
              if(n===true && this.djscount>0){
                  let clear=setInterval(()=>{
                      this.djscount--;
                      if(this.djscount<=0){
                          this.courseshow=false;
                          clearInterval(clear);
                      }
                  },1000);
              }
          },
          immediate: true
      },
  },
  async created () {

    this.courseId = Number(this.$route.query.courseId);
    if (sessionStorage.getItem('IosInif')) {
      this.imgOrPdf = false
    }
    if(this.$route.query.taskType && Number(this.$route.query.taskType)===2){
      await this.findTaskRule()
    }else if(this.$route.query.taskType && Number(this.$route.query.taskType)===1){
      await this.findTrainBasicInfoById()
    }

    this.findCourseInfo();
  },
  async mounted () {
    const u = navigator.userAgent;
    this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
    //手机自带返回
    if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新
        window.addEventListener("popstate", this.goback, false); //false阻止默认事件
    }


    if (+this.TrainBasicInfo.isAlertWindow == 0) {
      console.debug("this.TrainBasicInfo.isAlertWindow", this.TrainBasicInfo.isAlertWindow)
      this.videoInfo.notdialog = false
    }
    await this.getAccountUserInfo()
    if (this.$route && +localStorage.getItem("firstfaceauth") === 1) {
      localStorage.setItem("firstfaceauth", 0)
      localStorage.setItem("faceidentify", 1)

      this.$router.replace({ path: this.$route.path, query: { ...this.$route.query, mark: Math.random() } })
    }
    const userInfo = localStorage.getItem('WDuserInfo') ? JSON.parse(localStorage.getItem('WDuserInfo')) : {}
    this.WDuserInfo = JSON.parse(localStorage.getItem('WDuserInfo'))
    Object.keys(userInfo).forEach(key => {
      if (userInfo[key]) {
        this.$store.state.userInfo[key] = userInfo[key]
      }
    })
    this.findCourseItemByCourseId();

    await this.getEvaluationInfo();
  },
  computed: {},
  methods: {
      /**
       * 开始播放
       */
      async startPlay(){
          console.log('===开始播放====');

          clearInterval(this.IntervalName)
            await this.timing()
            this.videoInfo.fastForward = false
            this.videoInfo.IosInif = false

            if (this.studyProcess < 100) {
              if (+localStorage.getItem("faceidentify") === 0 && +this.TrainBasicInfo.isFaceRecognize === 1) {
                  this.$refs.Aliplayer.player.pause()
                  this.judgefaceauth()
                  return
              }
            }
            if (!this.videoInfo.detect) {
                this.$refs.Aliplayer.player.pause()
                return
            }
      },
    /**
     * 播放结束
     */
    async playEnd(){

        // 视频结束之后清除 弹屏 定时器
        clearTimeout(this.timeoutDialogAlert)

        // 结束之后调取保存接口
        await this.postCourseLearningLogSaveLog();

        console.log('======视频播放结束====')
        if (this.endedStatue) {
            this.endedStatue = false
            this.clearTimeing();
            this.videoInfo.deadline = 0
            this.sourceId = this.sourceId + 1;
            // 清除保存进度
            localStorage.removeItem('videoTime');
            /**
             * 课程目录顺序播放
             */
            if (this.sourceId < this.allresouce.length) {

                this.currentlyPlay = this.allresouce[this.sourceId]
                await this.selectPlay(this.currentlyPlay);
                // 重新获取目录
                await this.findCourseItemByCourseId(true);

            } else {
                /**
                 * 如果是培训任务 里面多个课程直接播放第二个课程
                 */
                this.getNextCourseInfo()

            }
            setTimeout(() => {
                this.endedStatue = true
            }, 300);
        }

    },
    /**
     * 播放暂停
     */
    async playPause(){
        /**
         * 清除保存接口定时器
         */
        await this.clearTimeing();
    },
    courseshowbtn(){
        this.courseshow=false;
    },
    goback(){
      setTimeout(()=>{
        if(this.$route.query.taskType && Number(this.$route.query.taskType)===2){
            this.$router.push({
              name: 'trainDetails',
              query: { id: this.$route.query.trainId,backType:this.$route.query.backType },
            })
        }else if(this.$route.query.taskType && Number(this.$route.query.taskType)===1){
          this.$router.push({
            name: 'learningDetails',
            query: { id: this.$route.query.trainId,backType:this.$route.query.backType },
          })
        }
      },1000)


    },
    clickclose(){
      this.playboxscore=false;
      this.$refs.Aliplayer && this.$refs.Aliplayer.player && this.$refs.Aliplayer.player.play();
      this.$forceUpdate;
    },
    playboxscoreclick(){
      if(this.studyProcess >=30){
        this.playboxscore=true;
        console.log(this.$refs.Aliplayer,'this.$refs.Aliplayer')
        this.$refs.Aliplayer && this.$refs.Aliplayer.player && this.$refs.Aliplayer.player.pause();
      } else {
        this.$toast({
            message:'课程学习进度未达到30%，不能进行评价',
            className:'courseToast'
        });
      }
    },
    async getEvaluationInfo(){
      let params = {
        courseId: this.courseId
      }
      await this.$api.course.getEvaluationInfo({ params }).then(res => {
        if (res.data) {
          this.count1=res.data.aveScore?res.data.aveScore:5;
          this.count=res.data.aveScore?Math.ceil(res.data.aveScore):5;
          this.myScore=res.data.myScore?Math.ceil(res.data.myScore):0;
          this.$forceUpdate;
        }
      });
    },
    async evaluateCourse(count){
      const data = {
        courseId: this.courseId,
        score:count,
      }
      await this.$api.course.evaluateCourse({ data }).then(res => {
        this.clickclose()
        this.getEvaluationInfo();
      })
    },

    close (val) {
      this.isfacedialog = val
    },
    isPic () {
      return this.videoInfo.IosInif && +localStorage.getItem('faceidentify') === 0
    },

    async playerDispose() {

      return new Promise((res, rej) => {
        try {
          this.$refs.Aliplayer && this.$refs.Aliplayer.player && this.$refs.Aliplayer.player.dispose();
        //   this.$refs.Aliplayer.player = null;
          res(true)
        } catch (error) {
          rej(error)
        }
      })
    },
    async cutoverClarity (clarity) {
      this.$refs.Aliplayer.player && this.$refs.Aliplayer.player.getCurrentTime() && (this.currentlyPlay.studyInfo.playLength = this.$refs.Aliplayer.player.getCurrentTime())
      await this.playerDispose();
      this.clarityShow = false;
      this.videoInfo.videoClarity = clarity || this.videoInfo.videoClarity;

      await this.$refs.Aliplayer.getAliplayer(this.videoInfo.source, this.videoInfo);
    },
    /**
     * 获取任务里下一个课程
     */
     getNextCourseInfo(){
        let params = {
            courseId:this.courseId, // 当前课程ID
            taskId:this.$route.query.trainId, // 当前任务训练营ID
        }
        /**
         * courseId 当前课程id
         * nextCourseId 下一个课程id
         * nextCourseName  下一个课程名称
         * nextCourseNullType nextCourseId 为空时的原因类型，0 代表已全部学完，1 代表下一个课程未解锁
         */
         this.$api.course.getNextCourseInfo({params}).then(async (res) => {

            this.courseId = res.data.nextCourseId || res.data.courseId;
            this.findCourseInfo()
            if(res.data.nextCourseNullType === 1 && !res.data.nextCourseId){
                this.$toast({
                        message:'下一个课程未达到解锁规则，请返回任务大纲，按规则进行学习',
                        className:'courseToast'
                    });
            }else if(res.data.nextCourseNullType === 0 && !res.data.nextCourseId){
                this.$toast({
                    message:'已经是最后一个内容了',
                    className:'courseToast'
                });
            }else {
                this.allresouce = [];// 进来之前清空上一个课程所有资源

                await this.findCourseItemByCourseId();
                this.sourceId = 0;
                this.currentlyPlay = this.allresouce[this.sourceId];
                if(this.currentlyPlay?.studyInfo){
                    this.currentlyPlay.studyInfo.playLength = 0
                }
                await this.selectPlay(this.currentlyPlay);
            }

        })
    },
    // 章节展开
    handleToggle (item,type) {
      if(item.lock){
          this.coursetxt='该章未开启';
          this.djscount=2;
          this.courseshow=true;
          return;
      }
      if(type===1){
        if (this.currentCourseId === item.id) {
          this.currentCourseId = null
        } else {
          this.currentCourseId = item.id || ''
        }
      } else if (item.type===10) {
        this.userPracticejoinExam(item.detailId);
      }else if(item.type===11){
          goLiveHome(this, item.liveRoomId,item)
        //   if(item.detailId){
        // }else{
        //   this.$api.live.getBjyPlayUrl({liveCourseId: item.liveRoomId}).then(async (urlRes) => {
        //     if (urlRes.data.roomStatus==4) {
        //       this.coursetxt='直播已结束';
        //     } else {
        //       this.coursetxt='暂未关联直播，请稍后查看';
        //     }
        //     this.djscount=2;
        //     this.courseshow=true;
        //     return;
        //   })
        //   // this.coursetxt='暂未关联直播，请稍后查看';
        //   // this.djscount=2;
        //   // this.courseshow=true;
        //   // return;
        // }

      }else if(item.type===12){
        this.coursetxt='实训无法在手机上进行，请前往电脑网页端';
        this.djscount=2;
        this.courseshow=true;
        return;
      }else{
        this.selectPlay(item);
      }

    },
    async selectPlay (el) {
        console.log(el,'el======')
        /**
         * this.sourceId 重新赋值
         * 为了点击元素下标不对的原因
         */
        this.isDraw = this.TrainBasicInfo.isDraw;
        this.isDoubleSpeed = this.TrainBasicInfo.isDoubleSpeed;
        this.playCover = false;
        const is = this.allresouce.some((item, index) => {
            if (item.id === el.id) {
                this.sourceId = index
                return false;
            }
        })
      this.videoInfo.deadline = 0

      if ([1, 2].includes(+el.type)) {
        await this.playerDispose().then(()=>{
          // 音频 和 视频 阿里配置
            return  this.getPlayAuthToken(el)
        })
        if (+el.type === 1) {
          this.videoInfo.videoType = {
            format: 'm3u8',
            mediaType: 'video'
          }
        } else {
          this.videoInfo.videoType = {
            format: 'mp3',
            mediaType: 'audio'
          }
        }
        await this.$refs.Aliplayer.getAliplayer(this.videoInfo.source, this.videoInfo);
        this.videoInfo.playPlayer = true
      }
      if (el) {
        this.currentlyPlay = el
      } else {
        this.currentlyPlay = {
          ...this.currentlyPlay
        }
      }
      this.WDuserInfo = JSON.parse(localStorage.getItem('WDuserInfo'))
      if (+this.TrainBasicInfo.isFaceRecognize === 1) {
        if (+this.WDuserInfo.idAuthStatus !== 1) {
          this.$router.push({
              path:'/idcard',
              query:{
                  courseId: this.courseId,
                  trainId: this.$route.query.trainId || '',
                  studyProcess:this.studyProcess,
                  backType:this.$route.query.backType,
                  taskType:this.$route.query.taskType,
              }
          }); // 跳转到实名认证
          return;
        }

        if (this.studyProcess < 100) {
          if (+localStorage.getItem("faceidentify") === 0 && +this.TrainBasicInfo.isFaceRecognize === 1) {
            this.judgefaceauth()
            return;
          }
        }
      }
      this.isstartPlay = true;

      if ((this.dateExpireStatus && this.dateExpireStatus == 2) || (this.currentlyPlay.dateExpireStatus && this.currentlyPlay.dateExpireStatus == 2)) {
        this.$notify({
          type: "warning", message: "已过期不可查看",
        });
        return;
      }
      this.videoInfo.fastForward = false
      clearTimeout(this.timeoutDialogAlert)
      /**
       * isAlertWindow: 弹屏开启 1 开启 0 关闭
       * alertType: 弹屏类型 1 按次数 0 按时间
       * alertTime：弹屏时间
       */
      if (this.TrainBasicInfo.isAlertWindow && !this.TrainBasicInfo.alertType) {
        await this.dialogAlert()
      }

      if ([3, 4].includes(+el.type)) {
          if(el.type === 3){
              await this.getDocumentAccessToken(el)
              await this.getSourseDetail(el);
          }else {
            await  this.getImageOrDocUrl(el)
          }
          this.$router.push({
            path: "/showPdf",
            // query: {
            //   pdfurl: this.videoInfo.url,
            //   type:el.type,
            //   accessToken:this.accessToken,
            //   courseId:this.courseId,
            //   taskId: this.$route.query.trainId || '',
            //   courseItemId: this.currentlyPlay.id,
            //   cur: (this.currentlyPlay && this.currentlyPlay.studyInfo && this.currentlyPlay.studyInfo.playLength) || 1,
            //   courseInfo: JSON.stringify(this.currentlyPlay),
            //   pollingTime: 5,
            //   backType:this.$route.query.backType,
            //   taskType:this.$route.query.taskType,
            //   fileUrl:this.fileUrl,
            //   duration:this.currentlyPlay.duration
            // }
            query: {
                id:el.detailId,
                type:el.type,
                courseId:this.courseId,
                taskId: this.$route.query.trainId || '',
                courseItemId: this.currentlyPlay.id,
                pollingTime: 5,
                name:el.contentName, // 文档名称
                duration:el.duration, // 总页数
                backType:this.$route.query.backType,
                taskType:this.$route.query.taskType,
                taskType:this.$route.query.taskType,
            }
          })
        }
    },


    userPracticejoinExam(id){
      let params = {practiceId:id};
      this.$api.exam.userPracticejoinExam({ params }).then(({ data }) => {
          this.$router.push({
            path: "/testpage",
            query: {
              practiceId:id,
              userPracticeId:data,
              backType:this.$route.query.backType,
              trainId:this.$route.query.trainId,
              courseId:this.courseId,
              taskType:this.$route.query.taskType,
            }
          })
      });
    },
    // 实名认证与人脸识别
    async judgefaceauth () {
      if (+this.TrainBasicInfo.isFaceRecognize === 1 && +localStorage.getItem("firstfaceauth") === 0) {
        this.isfacedialog = true
      }
    },
    // 课程与介绍切换
    async changecourseType (item) {
      this.changetype = item.id;

    },
    /**
     * 获取课程大纲目录
     */
    async findCourseItemByCourseId (list) {
      let params = {
        courseId: this.courseId,
        taskId: this.$route.query.trainId,
        taskType:this.$route.query.taskType
      }
      const { data } = await this.$api.course.findCourseItemByCourseId({ params });
      this.catelogList = data
      if (list) {
        this.allresouce.forEach((item, index) => {
          if (item.id === this.currentlyPlay.id) {
            this.sourceId = index
          }
        })
        return
      }
      if (data && data.length) {
        await this.getAllavedio(data)
      }
      const is = this.allresouce.some((item, index) => {
        if (item.studyInfo && item.studyInfo.lastPlay) {
          this.sourceId = index
          this.currentlyPlay = this.allresouce[this.sourceId]
          return true
        } else {
          return false
        }
      })
      if (!is) {
        this.sourceId = 0
        this.currentlyPlay = this.allresouce[0]
      }
    //   this.currentlyPlay && await this.getPlayAuthToken(this.currentlyPlay);
        /**
         * 人脸识别成功 生成播放器
         */
        console.log(this.currentlyPlay,'this.currentlyPlay')
        if(+localStorage.getItem('faceidentify') === 1){
            this.selectPlay(this.currentlyPlay);
            // this.$refs.Aliplayer.getAliplayer(this.videoInfo.source, this.videoInfo);
        }
    },
    /**
     * 获取视频播放地址
     */
    async getPlayAuthToken (currentlyPlay) {
      if (currentlyPlay && currentlyPlay.detailId || this.currentlyPlay.detailId) {
        const params = {
          resId: currentlyPlay ? currentlyPlay.detailId : this.currentlyPlay.detailId
        }
        await this.$api.resource.getPlayAuthToken({ params }).then(res => {
            if(res.data){
                this.videoInfo.source = res.data;
            }

        })

      }
    },
    /**
     * 获取文档密钥
     */
    async getDocumentAccessToken (currentlyPlay) {
      if (currentlyPlay && currentlyPlay.detailId || this.currentlyPlay.detailId) {
        const params = currentlyPlay ? currentlyPlay.detailId : this.currentlyPlay.detailId

        return this.$api.resource.getDocumentAccessToken(params).then(res => {
          if (res.success) {
              this.videoInfo.url = res.data.previewURL;
              this.accessToken = res.data.accessToken;
            }
        })
      }
    },
    /**
     * 文档地址
     */
    async getSourseDetail(data){
        const params = {
            id:data.detailId
        }
        return this.$api.resource.getSourseDetail({params}).then(res => {
            if(res.data){
                this.fileUrl = res.data.fileUrl
            }
        })
    },
    /**
     * 图片地址
     */
    async getImageOrDocUrl (currentlyPlay){
        if (currentlyPlay && currentlyPlay.detailId || this.currentlyPlay.detailId) {
            const params = {
                id:currentlyPlay ? currentlyPlay.detailId : this.currentlyPlay.detailId,
                // courseId:this.$route.query.courseId
            }
            return this.$api.resource.getImageOrDocUrl({params}).then(res => {
                if (res.success) {
                    this.videoInfo.url = res.data;
                }
            })
        }
    },
    /**
     * 保存进度
     */
    async postCourseLearningLogSaveLog () {
      let video = document.querySelector('video')
      if (+this.currentlyPlay.type === 2) {
        video = document.querySelector('audio')
      }
      let cur = video && video.currentTime || 1;
      const max = video && video.duration || 1;
      /**
       * 如果进度小于10秒，直接保存总进度
       */
      if((video?.duration - video?.currentTime) <= 10){
          cur = video.duration;
      }
      // 实时存储进度条变化
      localStorage.setItem('videoTime',cur);
      const data = {
        // courseId:this.toStudyByQuick? this.currentResource.courseId:this.$route.query.courseId, //通过快速学习方式、普通学习方式
        courseId:this.courseId,
        taskId: this.$route.query.trainId || '',
        taskType:this.$route.query.taskType,
        courseItemId: this.currentlyPlay.id,
        cur,
        max,
        pollingTime: 5
      }
      for (let key in data) {
        if (!data[key]) {
          console.log(key, '---key---', data[key])
        }
      }
      return await this.$api.course.postCourseLearningLogSaveLog({ data }).then(res => {
          this.saveLogCode = res.code;

        console.debug(res)
      }).catch(err => {
          this.saveLogCode = null;
      })
    },
    async postUserLearningLog () {
      const data = {
        learningLength: 5
      }
      await this.$api.course.postUserLearningLog({ data }).then(res => {
        console.debug(res)
      })
    },
    // 清除定时器
    async clearTimeing () {
      if (this.IntervalName) {
        clearInterval(this.IntervalName);
      }
    },
    // 定时器
    async timing () {
      this.IntervalName = setInterval(async () => {
        if (this.$route.name === 'scourse') {
          this.postCourseLearningLogSaveLog();
          this.postUserLearningLog();
        }
      }, this.saveLogtime);
      return this.IntervalName
    },
    // 获取目录中的所有资源文件
    async getAllavedio (data) {
      if (!data) {
        return;
      }
      data.forEach(item => {
        if (item.detailId && [1, 2].includes(+item.type)) {
          this.allresouce.push(item)
        } else if (item.childrenList && item.childrenList.length > 0) {
          return this.getAllavedio(item.childrenList)
        }
      })
    },
    async findTrainBasicInfoById () {
      const params = {
        id: this.$route.query.trainId || ''
      }
      return this.$api.training.findTrainBasicInfoById({ params }).then(async res => {
        this.TrainBasicInfo = res.data
      })
    },
    async findTaskRule () {
      const params = {
        taskId: this.$route.query.trainId || ''
      }
      return this.$api.learning.findTaskRule({ params }).then(async res => {
        this.TrainBasicInfo = res.data;
        this.TrainBasicInfo.isFaceRecognize=res.data.isCourseFaceRecognize;
      })
    },

    dialogAlert () {
      this.timeoutDialogAlert = setTimeout(() => {
        if (this.$route.name === 'scourse') {
          this.videoInfo.detect = false
          this.$refs.Aliplayer.player.pause()
          this.exitFullscreen()
          this.$dialog.alert({
            confirmButtonText:'我在，继续学习',
            message: this.TrainBasicInfo.alertWindowTip || '亲爱的学员，还在吗？请不要走开，点击 ”我在“继续学习，否则您离开的时间将不计入学时',
          }).then(() => {
            this.videoInfo.detect = true
            this.dialogAlert();
            this.$refs.Aliplayer.player.play()
          })
        }
        //解决只弹出一次确认弹窗的问题
        // this.clearTimeing();
      }, (this.TrainBasicInfo.alertTime || 10) * 60000)
      // }, 5000)
    },
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if(document.oRequestFullscreen){
            document.oCancelFullScreen();
        }else if (document.webkitExitFullscreen){
        document.webkitExitFullscreen();
      }else{
        var docHtml  = document.documentElement;
        var docBody  = document.body;
        // var videobox  = document.getElementById('videobox');
        docHtml.style.cssText = "";
        docBody.style.cssText = "";
        // videobox.style.cssText = "";
        document.IsFullScreen = false;
      }
    },
    // 获取描述
    async findCourseInfo () {
      let params = {
        courseId: this.courseId,
        taskId: this.$route.query.trainId,
        taskType:this.$route.query.taskType
      }
      const { data } = await this.$api.course.findCourseInfo({ params });
      this.WDuserInfo = JSON.parse(localStorage.getItem('WDuserInfo'))
      if(!data.userLearnInfo){
        this.studyProcess = 0
      }else{
        this.studyProcess = data.userLearnInfo.learnRate || 0
      }
      this.userLearnInfo=data.userLearnInfo;
      this.dateExpireStatus = data.dateExpireStatus;
      this.description = data;
      this.descriptionImg = (data && data.pic) || 'https://raas-prod.oss-cn-beijing.aliyuncs.com/hrss/default-picture/course2.png'
    },

    async getAccountUserInfo () {
      return this.$api.usercenter.getAccountUserInfo({}).then(res => {
        if (res.data) {
          this.$store.state.userInfo = {
            ...this.$store.state.userInfo,
            ...res.data
          }
          localStorage.setItem('WDuserInfo', JSON.stringify(this.$store.state.userInfo))
        }
      })
    }
  },
  destroyed () {
    clearInterval(this.IntervalName);
    clearTimeout(this.timeoutDialogAlert)
    // 清除保存进度
    localStorage.removeItem('videoTime');
    this.playerDispose()

    localStorage.setItem('faceidentify', 0)
      window.removeEventListener("popstate", this.goback, false); //false阻止默认事件
  }
};
</script>
<style scoped lang="stylus">
  @import '../asset/css/index.styl'
.courseDetail{
    position:relative ;
}
 .clarityStyle{
    position absolute
    z-index 2
    top 23px
    right 32px
    li {
      &.fr{
        font-size 24px
        width 72px
        height 40px
        line-height 40px
        text-align center
        font-size 23px
        border-radius 3px
        color #fff
        border 1px #fff solid
        color #333
        background-color #e5e5e5
      }
      &.currently.fr{
        color #FFFFFF
        background-color rgba(0,0,0,.3)
      }
    }
  }
  .detail-foot {
      position: fixed;
      bottom: 0;
      width: 100%;
      height: 98px;
      background: #ffffff;
      text-align: center;
      box-shadow: 0px 2px 0px 0px #EAEAEA;
      z-index: 100;
    button {
        width: 690px;
        height: 80px;
        text-align: center;
        line-height: 80px;
        background: linear-gradient(136deg, #407DF7 0%, #416DF6 100%);
        border-radius: 44px;
        border: 0;
        font-size: 32px;
        margin-top: 10px;
        color: #ffffff;
    }
    &.isMinzheng button {
        background: #CA4C2D;
    }
  }
  /* eslint-disable no-new */
</style>

<style lang="stylus">
.playPlayer {
  min-height:210PX;
  width: 100%;
  position: relative;
  overflow:hidden;

  #audioEl {
    position: relative;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 430px;
    z-index: 91;

    img {
      width: 100%;
      height: 440px;
      position: absolute;
      top: -5px;
    }

    &>div {
      position: absolute;
      bottom: 18px;
      width: 750px;
      height: 100px;
    }

    .van-slider__button {
      width: 12px;
      height: 12px;
    }

    .van-slider {
      display: inline-block;
      top: -4px;
    }

    span {
      width: 20%;
      display: inline-block;
      text-align: center;
      color: #fff;
      font-size: 24px;
    }

    .van-icon {
      font-size: 34px;
      top: 10px;
      left: 15px;
      margin-right: 10px;
      color: #fff;
    }
  }
}

.courseDetail .playPlayer .prism-player .prism-controlbar {
  display: block !important;
}

.picImg {
  width: 100%;
  height: 210PX;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 440px;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 90;
  margin-left: -50%;
  text-align: center;
  .picImg-img{
    // width: 100%;
    height: 440px;
  }
}

.picBfImg {
  width: 120px;
  position: absolute;
  z-index: 91;
  margin-left: -60px;
  top: 180px;
  left: 50%;
}

.courseDetail-content {
  position: relative;
}

.detectnone {
  display: none;
}

.detect {
  width: 750px;
  height: 420px;
  background-color: #252533;
  position: absolute;
  z-index: 10;
  text-align: center;

  &>div {
    font-size: 28px;
    color: #FFFFFF;
    line-height: 44px;
    padding: 90px 50px;
    font-size: 16px;
  }

  .van-button {
    width: 160px;
    background-color: #252533;
    color: #fff;
  }
}

#player-con {
  position: relative;
  z-index: 9;
}

#J_prismPlayer {
  overflow: hidden;
}

html, body, .wdc-app {
  // height 100%
  max-height: 100%;
  background: #fff;
}

.courseDetail {
  height: 100%;
  background: white;
}

.category-wraper {
  padding: 0 30px;

  .category-item {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 30px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 24px;
    border: 1px solid #D9D9D9;
  }

  .category-item-header {
    position: relative;
    width: 100%;
    height: 100px;
    padding: 0 30px;
    font-size: 17PX;
    line-height: 100px;
    font-weight: bold;
    color: #333333;
    box-sizing: border-box;

    .title {
      width: 520px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &.actived {
      border-bottom: 1px solid #EAEAEA;
    }

    .open {
      position: absolute;
      right: 30px;
      top: 33px;
      display: flex;
      flex-flow: row;
      align-items: center;
      justify-content: center;
      width: 46px;

      &.actived {
        .arrow-icon {
          transform: rotate(90deg);
          font-size:40px;
          color:#999;
        }
      }

      .arrow-icon {
        font-size:40px;
        color:#999;
        font-weight:600;
        transform: rotate(-90deg);
      }
    }
  }

  .section-title {
    padding: 0 30px;
    padding-top: 32px;
    margin-bottom: 10px;
    font-size: 15PX;
    color: #000000;
  }

  .chapter-title {
    display: flex;
    flex-flow: row;
    align-items: center;
    padding: 0 30px;

    .radio {
      width: 16px;
      height: 16px;
      margin-right: 16px;
      border-radius: 50%;
      background: #3760FF;
    }

    p {
      flex: 1;
      height: 90px;
      line-height: 90px;
      font-size: 13PX;
      color: #333333;
      border-bottom: 1px solid #EAEAEA;
    }
  }

  .small-section-title {
    height: 80px;
    padding: 0 30px;
    padding-left: 60px;
    line-height: 80px;

    p {
      font-size: 13PX;
      border-bottom: 1px solid #EAEAEA;
      color: #333333;
    }
  }

  .chapter-course {
    // height: 80px;
    padding: 25px 30px;
    padding-left: 60px;

    &.active {
      background: #F7F7F7;
      position: relative;
      z-index: 9;

      .course-content {
        border-bottom: none;
      }
    }

    .course-content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-flow: row;
      align-items: center;
      font-size: 13PX;
      color: #666666;
      position: relative;

      .course-label {
        flex-shrink: 0;
        text-align: center;
        // min-width: 48px;
        // min-height: 26px;
        margin-right: 5PX;
        padding: 1PX 2PX;
        font-size: 9PX;
        color: #7B37FF;
        border-radius: 4px;
        border: 1px solid #0B9424;
      }
      .course-label-blue{
        color: #3760FF;
        border-color:#3760FF;
      }
      .course-label-glay{
        color: #999999;
        border-color:#999999;
        .course-title{
          .course-title-name{
            color: #999999;
          }

        }
      }
      .course-label-video {
        color: #7B37FF;
        border-color: #7B37FF;
      }

      .course-label-file {
        color: #0B9424;
        border-color: #0B9424;
      }

      .course-label-audio {
        color: #0159FF;
        border-color: #0159FF;
      }

      .course-label-img {
        color: #FFA302;
        border-color: #FFA302;
      }

      .course-num {
        padding-right: 8px;
        font-size: 13PX;
      }
      .course-status {
        margin-left: 30px;
        font-size: 26px;
        color: #0159FF;
        position: relative;
        img{
            width: 44px;
            height: 44px;
            position: absolute;
            left: -30px;
            top: 0;
        }
      }
    }
  }
}

.iframeStyle {
  position: fixed;
  top: 0;
  left: 0;
}
.coursedialog{
    width: 590px;
    padding: 48px;
    box-sizing: border-box;
    .van-dialog__content{
        text-align: center;
        .coursedialog-content{
            font-size: 0.853rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #202124;
            line-height: 1.28rem;
            margin-bottom: 1.28rem;
        }
        .coursedialog-btn{
            width: 100%;
            height: 2.1333rem;
            border-radius: 1.173rem;
            border: 1px solid #415FF6;
            font-size: 0.853rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #415FF6;
            line-height: 2.1333rem;
            background: #FFFFFF;
            &::before{
                background-color: #FFFFFF;
            }
        }
    }
}
.content-info-course{
  p{
    img{
        max-width: 100%;
        height:auto;
    }
  }
}
</style>
